export { default as settingsReducer } from "./slice";
export { useSettings } from "./hooks";
export { useGetSettingsQuery, usePrefetch } from "./endpoints";
